<template>
  <div>
    <div id="guide-nav" class="fixed-right">
      <b-list-group>

        <!-- Main title with search and breadcrumb -->
        <b-list-group-item
            class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-4"
        >
          <b-nav-item-dropdown right extra-toggle-classes="no-dropdown-caret" class="guide-settings">
            <!-- Using 'button-content' slot -->
            <template slot="button-content">
              <span class="float-right" style="list-style: none;">
                <font-awesome-icon size="lg" icon="cog"/>
              </span>
            </template>

            <div class="pl-4 pr-4">
              <b-form-checkbox
                v-model="settingsForm.hide_update_task_guide"
                name="checkbox-disable"
                :value="1"
                @change="updateSettings"
                :unchecked-value="0"
              >
                {{ $t('system.hide_update_task_guide') }}
              </b-form-checkbox>
              <br>
              <b-form-checkbox
                v-model="settingsForm.hide_validation_task_guide"
                name="checkbox-disable"
                :value="1"
                @change="updateSettings"
                :unchecked-value="0"
              >
                {{ $t('system.hide_validation_task_guide') }}
              </b-form-checkbox>
              <br>
              <b-form-checkbox
                v-model="settingsForm.hide_control_task_guide"
                name="checkbox-disable"
                :value="1"
                @change="updateSettings"
                :unchecked-value="0"
              >
                {{ $t('system.hide_control_task_guide') }}
              </b-form-checkbox>
              <br>
              <b-form-checkbox
                v-model="settingsForm.hide_assessment_task_guide"
                name="checkbox-disable"
                :value="1"
                @change="updateSettings"
                :unchecked-value="0"
              >
                {{ $t('system.hide_assessment_task_guide') }}
              </b-form-checkbox>
            </div>
            <hr>
            <div class="pl-4 pr-4">
              <small class="text-muted">
                * {{ $t('system.global_guide_explainer_text') }}
              </small>
            </div>
          </b-nav-item-dropdown>
          <h6>
            {{ $t('system.help_center_label') }}
          </h6>
          <b-form-input
            qid="create-guide-form-name"
            type="text"
            v-model="searchKeyword"
            v-on:input="debounceInput"
            :placeholder="$t('system.search_topic')"
          ></b-form-input>
          <br>
          <a @click="showRootMenuFunction()">
            {{ $t('system.help_center_label') }}
          </a>
          <span v-if="activeContentType && !showRootMenu">
            >
            <a @click="selectContentType(undefined, true)">
              {{ $t('administration.guide.content.' + $options.filters.slugify(activeContentType)) }}
            </a>
          </span>
          <span v-if="activeGuide && activeGuide.id && !showRootMenu">
            > <span>{{ activeGuide.title }}</span>
          </span>
        </b-list-group-item>

        <!-- Active guide data -->
        <b-list-group-item
            class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-3"
            v-if="activeGuide && activeGuide.id && !searchKeyword && !showRootMenu"
        >
          <span class="btn btn-secondary btn-xs float-right cursor-pointer ml-2" @click="showViewGuideModal(activeGuide)">
            <font-awesome-icon icon="eye" />
            {{ $t('administration.guide.modal.button') }}
          </span>
          <h6 class="mb-4 mt-2">
            {{ activeGuide.title }}
          </h6>
          <p class="text-formatted" v-html="activeGuide.description"></p>

          <div v-if="activeGuide.media && activeGuide.media.length" class="mt-3">
            <label>{{ $t('system.media_label') }}</label>
          </div>
          <div v-for="media in activeGuide.media">
            <video width="318" controls :src="media.url"></video>
          </div>

        </b-list-group-item>

        <!-- List of guides for selected content type -->
        <b-list-group-item
            class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-3"
            v-if="activeContentType && !activeGuide.id && !showSearchResults"
            v-for="scope in getContentScopes(activeContentType)"
        >
          <h6><a @click="selectGuide(scope)">{{ scope.title }}</a></h6>
        </b-list-group-item>

        <!-- List of search results -->
        <b-list-group-item
            class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-3"
            v-if="showSearchResults && !showRootMenu"
            v-for="result in myGuides"
        >
          <h6><a @click="selectGuide(result)">{{ result.title }}</a></h6>
        </b-list-group-item>

        <!-- List of content types - Root menu -->
        <b-list-group-item
            class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-3"
            v-if="showRootMenu"
            v-for="content in contentTypes"
        >
          <h6><a @click="selectContentType(content.value)">{{ content.name }}</a></h6>
        </b-list-group-item>

      </b-list-group>
      <hr class="mt-0"/>
      <div class="text-center text-muted" v-if="loading">
        {{ $t('system.loading')}}
      </div>
    </div>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import InfiniteLoading from 'vue-infinite-loading';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';

export default {
  name: 'GuideNavigation',
  data: function() {
    return {
      activeNavbar: this.$store.state.activeNavbar,
      language: this.$store.language,
      items: [],
      loading: true,
      myGuides: [],
      activeGuide: {},
      searchKeyword: '',
      activeContentType: '',
      showSearchResults: false,
      showRootMenu: false,
      selectedGuide: {},
      viewGuideModal: false,
      contentTypes: [
        { name: this.$t('administration.guide.content.process'), value: 'Process' },
        { name: this.$t('administration.guide.content.activity'), value: 'Activity' },
        { name: this.$t('administration.guide.content.system'), value: 'System' },
        { name: this.$t('administration.guide.content.third_party'), value: 'Third party' }
      ],
      settingsForm: {
        hide_update_task_guide: this.$store.state.user.hide_update_task_guide,
        hide_validation_task_guide: this.$store.state.user.hide_validation_task_guide,
        hide_control_task_guide: this.$store.state.user.hide_control_task_guide,
        hide_assessment_task_guide: this.$store.state.user.hide_assessment_task_guide
      }
    }
  },
  props: {

  },
  components: {
    InfiniteLoading,
    GuideViewModal
  },
  watch: {
    getActiveGuideObject: function (newValue, oldValue) {
      if (newValue && oldValue && ((newValue.id && oldValue.id && newValue.id != oldValue.id) || (newValue.id && !oldValue.id))) {
        this.loadGuides(newValue.scope)
      }
    },
    // getActiveTaskObject: function (newValue, oldValue) {
    //   let self = this;
    //   if (newValue && oldValue && newValue.id && oldValue.id) {
    //     let existingGuide = _.find(this.myGuides, function(object) {
    //       // Check if guide type property is matching stripped whoami from task model type
    //       if (object.type == "Third party") {
    //         return object.scope == newValue.code && newValue.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'
    //       } else {
    //         return object.scope == newValue.code && object.type == newValue.model_type.substring(newValue.model_type.lastIndexOf("\\") + 1, newValue.model_type.length)
    //       }
    //
    //     });
    //
    //     if (existingGuide) {
    //       setTimeout(function() {
    //         self.selectGuide(existingGuide)
    //       }, 300)
    //     } else {
    //       if (newValue.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
    //         self.selectContentType('Third party')
    //       } else {
    //         self.selectContentType(newValue.model_type.substring(newValue.model_type.lastIndexOf("\\") + 1, newValue.model_type.length))
    //       }
    //
    //     }
    //   }
    // }
  },
  computed: {
    getNavType() {
      return this.$store.state.activeNavbar
    },
    getClient() {
      return this.$store.state.client
    },
    getUser() {
      return this.$store.state.user
    },
    getActiveTaskObject() {
      return this.$store.state.activeTaskObject
    },
    getActiveGuideObject() {
      return this.$store.state.activeGuideScope
    },
    getTaskToolbarState() {
      return this.$store.state.taskToolbarState
    }
  },
  methods: {
    debounceInput: _.debounce(function() {
      this.showRootMenu = false;
      this.$store.commit('storeActiveGuideScope', {});
      this.activeGuide = {}
      this.loadGuides()
    }, 400),
    showViewGuideModal(object) {
      this.selectedGuide = object
      this.viewGuideModal = true
    },
    closeViewGuideModal() {
      this.selectedGuide = ''
      this.viewGuideModal = false
    },
    updateSettings() {
      let self = this
      piincHttp.put('users/' + this.getUser.slug, this.settingsForm).then(function(response) {
        let user = self.getUser
        user.hide_update_task_guide = response.data.hide_update_task_guide
        user.hide_validation_task_guide = response.data.hide_validation_task_guide
        user.hide_control_task_guide = response.data.hide_control_task_guide
        user.hide_assessment_task_guide = response.data.hide_assessment_task_guide
        self.$store.commit('storeUser', user);
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    loadGuides(code, setActive, option) {
      let self = this;

      piincHttp.get('https://complyon.com/wp-json/wp/v2/ht-kb?per_page=12&status%5B%5D=publish&orderby=article_views').then(function(response) {
        self.myGuides = response.data
      }, function() {});

      // let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
      //
      // piincHttp.get('guides', { params:
      //   {
      //     per_page: 150,
      //     keyword: this.searchKeyword,
      //     language: 'en',
      //     scope: code
      //   }
      // }).then(function(response) {
      //   self.loading = false;
      //   if (response.data.items.length) {
      //     self.myGuides = response.data.items
      //
      //     // if (setActive && self.getActiveTaskObject && self.getActiveTaskObject.id && self.getTaskToolbarState) {
      //     //   let existingGuide = _.find(self.myGuides, function(object) {
      //     //     // Check if guide type property is matching stripped whoami from task model type
      //     //     if (object.type == "Third party") {
      //     //       return object.scope == self.getActiveTaskObject.code && self.getActiveTaskObject.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'
      //     //     } else {
      //     //       return object.scope == self.getActiveTaskObject.code && object.type == self.getActiveTaskObject.model_type.substring(self.getActiveTaskObject.model_type.lastIndexOf("\\") + 1, self.getActiveTaskObject.model_type.length)
      //     //     }
      //     //   });
      //     //   setTimeout(function() {
      //     //     self.$store.commit('storeActiveGuideScope', existingGuide);
      //     //     self.showSearchResults = false
      //     //     self.searchKeyword = '';
      //     //   }, 300)
      //     // }
      //
      //     if (self.searchKeyword) {
      //       self.showSearchResults = true;
      //     } else if (option == 'root' || option == 'content') {
      //
      //     } else {
      //       if (self.getActiveGuideObject && self.getActiveGuideObject.id) {
      //         self.showRootMenu = false;
      //         self.activeGuide = self.getActiveGuideObject
      //         self.activeContentType = self.getActiveGuideObject.type
      //       } else {
      //         if (self.$route.name == 'activities.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('Activity')
      //         }
      //         if (self.$route.name == 'systems.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('System')
      //         }
      //         if (self.$route.name == 'processes.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('Process')
      //         }
      //         if (self.$route.name == 'contracts.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('Third party')
      //         }
      //         if (self.$route.name == 'risk_scenarios.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('Risk scenario')
      //         }
      //         if (self.$route.name == 'projects.view' && self.getActiveGuideObject && !self.getActiveGuideObject.id) {
      //           self.selectContentType('Project')
      //         }
      //       }
      //     }
      //
      //   }
      // }, function() {});
    },
    selectContentType(value, load) {
      if (value) {
        this.activeContentType = value;
      }
      this.activeGuide = {}
      this.$store.commit('storeActiveGuideScope', {});
      this.showRootMenu = false;
      if (load) {
        this.loadGuides(undefined, false, 'content')
      }
    },
    getContentScopes(contentType) {
      let filteredScopes = []
      _.forEach(this.myGuides, function (guide) {
        if (guide.type == contentType) {
          filteredScopes.push(guide)
        }
      })
      return filteredScopes;
    },
    selectGuide(item) {
      this.$store.commit('storeActiveGuideScope', item);
      this.showSearchResults = false
      this.searchKeyword = '';
    },
    showRootMenuFunction() {
      this.$store.commit('storeActiveGuideScope', {});
      this.showRootMenu = true;
      this.showSearchResults = false
      this.activeContentType = ''
      this.searchKeyword = ''
      this.loadGuides(undefined, false, 'root')
    }
  },
  created () {
    let self = this;

    if (this.getClient.riskModule) {
      this.contentTypes.push({ name: this.$t('administration.guide.content.generic_control'), value: 'Generic control' })
      this.contentTypes.push({ name: this.$t('administration.guide.content.risk_scenario'), value: 'Risk scenario' })
    }

    if (this.getClient.projectModule) {
      this.contentTypes.push({ name: this.$t('administration.guide.content.project'), value: 'Project' })
    }

    if (this.isGranted(this.permissions.MAINTENANCE_VIEW)) {
      this.contentTypes.push({ name: this.$t('administration.guide.content.maintenance'), value: 'Maintenance' })
    }

    if (this.$route.name != 'activities.view' &&
        this.$route.name != 'systems.view' &&
        this.$route.name != 'processes.view' &&
        this.$route.name != 'contracts.view' &&
        this.$route.name != 'risk_scenarios.view' &&
        this.$route.name != 'generic_controls.view' &&
        this.$route.name != 'projects.view'
      )  {
      this.showRootMenu = true;
    } else {
      if (this.$route.name == 'activities.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Activity')
      }
      if (this.$route.name == 'systems.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('System')
      }
      if (this.$route.name == 'processes.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Process')
      }
      if (this.$route.name == 'contracts.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Third party')
      }
      if (this.$route.name == 'risk_scenarios.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Risk scenario')
      }
      if (this.$route.name == 'generic_controls.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Generic control')
      }
      if (this.$route.name == 'projects.view' && this.getActiveGuideObject && !this.getActiveGuideObject.id) {
        this.selectContentType('Project')
      }
    }

    this.loadGuides(undefined, true)
  }
}
</script>
